import { render, staticRenderFns } from "./UserConfigInPreferences.vue?vue&type=template&id=b7702724&scoped=true"
import script from "./UserConfigInPreferences.vue?vue&type=script&lang=js"
export * from "./UserConfigInPreferences.vue?vue&type=script&lang=js"
import style0 from "./UserConfigInPreferences.vue?vue&type=style&index=0&id=b7702724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7702724",
  null
  
)

export default component.exports